import React, { useEffect, useRef, useState } from "react";
import { Button } from "../../../Components/ui/button";

const AreaNamePopover = ({ pendingArea, onConfirm, onCancel }) => {
  const [name, setName] = useState("");
  const inputRef = useRef(null);

  useEffect(() => {
    if (!pendingArea) return undefined;

    setName(pendingArea.name || "");
    const focusTimer = window.setTimeout(() => {
      inputRef.current?.focus();
    }, 50);

    return () => window.clearTimeout(focusTimer);
  }, [pendingArea?.tempId, pendingArea?.name]);

  if (!pendingArea) return null;

  const handleAdd = () => {
    if (!name.trim()) return;
    onConfirm(name.trim());
    setName("");
  };

  return (
    <div
      className='absolute right-5 top-24 z-20 w-[300px] p-4 bg-white rounded-xl shadow-lg border border-lightGray'
      onMouseDown={(e) => e.stopPropagation()}
      onClick={(e) => e.stopPropagation()}
      onDoubleClick={(e) => e.stopPropagation()}
    >
      <p className='text-sm font-bold text-primaryBlack mb-1'>Name this area</p>
      <p className='text-xs text-primaryAsh mb-3'>
        Adjust the boundary first, then add it to the zone.
      </p>
      <input
        ref={inputRef}
        className='w-full p-2.5 text-sm border border-lightGray rounded-md outline-none mb-3 focus:border-primaryGreen'
        placeholder='e.g. Marina Extension'
        value={name}
        onChange={(e) => setName(e.target.value)}
        onKeyDown={(e) => e.key === "Enter" && handleAdd()}
      />
      <div className='flex items-center gap-2'>
        <Button size='sm' onClick={handleAdd} disabled={!name.trim()}>
          Add
        </Button>
        <button
          type='button'
          className='text-xs text-primaryAsh hover:text-primaryBlack'
          onClick={() => {
            setName("");
            onCancel();
          }}
        >
          Discard
        </button>
      </div>
    </div>
  );
};

export default AreaNamePopover;
